import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { useNavigate } from '@change-corgi/core/react/router';

import { useStepState } from 'src/app/pages/startAPetition/pageContext';
import { useLoginState } from 'src/app/shared/hooks/session';

const LOGIN_REDIRECT_PATH = '/login_or_join';

export function useRedirectUnauthorized() {
	const { data } = useStepState();
	const loginState = useLoginState();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (data.currentStep.isAuthenticationRequired && loginState !== 'AUTHENTICATED') {
			const redirectUrl = encodeURIComponent(location.pathname + location.search);
			navigate(`${LOGIN_REDIRECT_PATH}?redirectTo=${redirectUrl}&user_flow=future_sap`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data.currentStep.isAuthenticationRequired]);
}
